export default {
  moneySymbol: '₫',
  tableForm: {
    search: 'Tìm kiếm',
    reset: 'Làm lại',
    submit: 'Gửi',
    collapsed: 'Mở rộng',
    expand: 'Thu gọn',
    inputPlaceholder: 'Nhập dữ liệu',
    selectPlaceholder: 'Vui lòng chọn',
  },
  alert: {
    clear: 'Xóa',
    selected: 'Đã chọn',
    item: 'mục',
  },
  pagination: {
    total: {
      range: ' ',
      total: 'trên',
      item: 'bản ghi',
    },
  },
  tableToolBar: {
    leftPin: 'Ghim sang trái',
    rightPin: 'Ghim sang phải',
    noPin: 'Bỏ ghim',
    leftFixedTitle: 'Cố định bên trái',
    rightFixedTitle: 'Cố định bên phải',
    noFixedTitle: 'Không cố định',
    reset: 'Làm lại',
    columnDisplay: 'Hiển thị cột',
    columnSetting: 'Cài đặt cột',
    fullScreen: 'Toàn màn hình',
    exitFullScreen: 'Thoát toàn màn hình',
    reload: 'Tải lại',
    density: 'Mật độ hiển thị',
    densityDefault: 'Mặc định',
    densityLarger: 'Rộng',
    densityMiddle: 'Trung bình',
    densitySmall: 'Thu nhỏ',
  },
};
